import React from 'react';
import ReactApexChart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';

const GraficoClientesAtivos = ({ chartOptions, series, seriesData }) => {
  return (
    <div id="bar-chart">
      <div className="grafico-titulo text-center ">
        <h4>Número de Clientes Ativos</h4>
      </div>
      {series ? (
        <ReactApexChart
          height="400"
          type="bar"
          options={chartOptions}
          series={seriesData(series, 'clientesAtivos')}
        />
      ) : (
        <Skeleton count={15} width={'100%'} height={20} />
      )}
    </div>
  );
};

export default GraficoClientesAtivos;
